<template>

  <drag-modal :visible="$store.state.dislog.preservation" @cancel="reset" :title='"添加进度-" + litetit' width='860px'
    :class='{ "editbox": Edit }'>
    <div class="navbox" v-if='Edit'>
      <Nscroll @delCopy='copydel' :openEdit='openEdit'></Nscroll>
      <div class="intopbtn" v-if='!isAllDis'>
        <a-popconfirm title="确认删除当前进度吗?" ok-text="确定" cancel-text="取消" @confirm="delStep" v-if="
          StepLite != 181 && $store.state.DisForm.infoList &&
          $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.del)
        ">
          <a-button type="danger" icon="delete" style="margin-left: 12px">删除</a-button>
        </a-popconfirm>
        <a-button icon="edit"
          v-if='$common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) && $store.getters.publicPower'
          style="margin-left:10px;" @click='openEdit = !openEdit'>{{ openEdit ? "修改" : "取消修改" }}</a-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="twobox">
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 10 }" :wrapper-col="{ span: 24 }">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="保全时间：" prop="preservation_time"
                :rules="{ required: true, message: '请选择保全时间', trigger: 'change' }" labelAlign="left"
                style="margin-top: -15px;">
                <a-date-picker v-model="form.preservation_time" placeholder="请选择保全时间" type="date"
                  valueFormat="YYYY-MM-DD HH:mm:ss" :disabled='openEdit' style="width:100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="裁定案号" labelAlign="left" style="margin-top: -15px;">
                <a-input v-model="form.ruling_case_no" placeholder='请输入裁定案号' :disabled='openEdit' v-if='!loading' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="执保案号" labelAlign="left" style="margin-top: -15px;">
                <a-input v-model="form.preservation_case_no" placeholder='请输入执保案号' :disabled='openEdit'
                  v-if='!loading' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="承办人" labelAlign="left" style="margin-top: -15px;">
                <div v-for='(i, index) in form.uname' :key='index' class="morebar">
                  <a-input v-model="i.v" placeholder='请输入承办人' :disabled='openEdit' />
                </div>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="联系方式" labelAlign="left" style="margin-top: -15px;">
                <div v-for='(i, index) in form.tel' class="morebar" :key="index">
                  <a-input v-model="i.v" placeholder='请输入联系方式' :disabled='openEdit' style="width: 100%;" />
                  <div class="btns" v-if='!openEdit'>
                    <a-icon type="plus-circle" class="i add" @click='add()' v-if='index == 0' />
                    <a-icon type="minus-circle" class="i del" @click='dels(index)' v-else />
                  </div>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="费用模式" prop='cost_model' labelAlign="left" style="margin-top: -25px;"
                :rules="{ required: true, message: '请选择费用模式', trigger: 'change' }">
                <a-select v-model="form.cost_model" placeholder="请选择费用模式" :disabled='openEdit'>
                  <a-select-option v-for="row in costmodelList" :key="row.id" :value="row.id">{{ row.option_name
                  }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="代理模式" prop='agent_model' labelAlign="left" style="margin-top: -25px;"
                :rules="{ required: true, message: '请选择代理模式', trigger: 'change' }">
                <a-select v-model="form.agent_model" @change="agentmodelChange(form.agent_model)" placeholder="请选择代理模式"
                  :disabled='openEdit'>
                  <a-select-option v-for="row in agentmodelList" :key="row.id" :value="row.id">{{ row.option_name
                  }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="立案代理人" prop='agent' labelAlign="left" style="margin-top: -25px;"
                :rules="{ required: true, message: '请选择立案代理人', trigger: 'change' }">
                <a-select v-model="form.agent" :placeholder="!openEdit ? '请选择立案代理人' : ''" mode="multiple"
                  :disabled='openEdit'>
                  <a-select-option v-for="row in agentList" :key="row.id" :value="row.id" :disabled="row.status == 0">{{
                    row.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="立案方式" class="ckbox" labelAlign="left" style="margin-top: -15px;">
              <div class="li" v-for="(i, index) in plainOptions" :key="index" :class="{ 'cur': i.value == form.type }"
                @click="!openEdit ? ck(i.value) : ''">{{ i.label }}</div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8" v-if='form.type == 1'>
              <a-form-model-item label="平台名称" prop="platform" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                <a-auto-complete :data-source="data" v-model='form.platform' @search="handleSearch"
                  placeholder="请填写平台名称" :disabled='openEdit' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 1'>
              <a-form-model-item label="材料提交时间" prop="time" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请选择材料提交时间', trigger: 'change' }">
                <a-date-picker v-model="form.time" placeholder="请选择材料提交时间" show-time type="date" style="width: 100%;"
                  valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="单号：" prop="ship_no" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                <a-input v-model="form.ship_no" :disabled='openEdit' placeholder='请输入单号' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="联系方式：" prop="contact_phone" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                <a-input v-model="form.contact_phone" :disabled='openEdit' placeholder='请输入联系方式' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="材料名称：" prop="filename" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                <a-input v-model="form.filename" :disabled='openEdit' placeholder='请输入材料名称' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="收件人：" prop="receive_name" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入收件人', trigger: 'blur' }">
                <a-input v-model="form.receive_name" :disabled='openEdit' placeholder='请输入收件人' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="寄出时间：" prop="ship_time" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                <a-date-picker v-model="form.ship_time" placeholder="请选择寄出时间" style="width: 100%;" show-time type="date"
                  valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item style="margin-top: -15px;">
                <label v-if='openEdit'>{{ form.gout == "a" ? "签收时间:" : (form.gout == "b" ? "拒收时间:" : "无") }}</label>
                <a-radio-group v-model='form.gout' :disabled='openEdit' size='small' style="white-space:nowrap;" v-else>
                  <a-radio-button :value="null" style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                  <a-radio-button :value="'a'"
                    style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                  <a-radio-button :value="'b'"
                    style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                </a-radio-group>
                <a-date-picker v-model="form.receive_time" placeholder="请选择" show-time valueFormat="YYYY-MM-DD HH:mm:ss"
                  format='YYYY-MM-DD HH:mm:ss' v-if='form.gout == "a"' :disabled='openEdit' style="width:100%;" />
                <a-date-picker v-model="form.return_time" placeholder="请选择" show-time valueFormat="YYYY-MM-DD HH:mm:ss"
                  format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit' style="width:100%;" v-if='form.gout == "b"' />
                <a-input disabled v-if='!form.gout' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 3'>
              <a-form-model-item :label="(StepLite == 121 ? '申请' : '立案') + '时间'" prop="time" labelAlign="left"
                style="margin-top: -15px;" :rules="{ required: true, message: StepLite == 121 ? '请选择申请时间' : '请选择立案时间', trigger: 'change' }">
                <a-date-picker v-model="form.time" :placeholder="StepLite == 121 ? '请选择申请时间' : '请选择立案时间'" style="width: 100%;" show-time type="date"
                  valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 3'>
              <a-form-model-item :label="(StepLite == 121 ? '申请' : '立案') + '地点'" prop="location" labelAlign="left"
                style="margin-top: -15px;" :rules="{ required: true, message: StepLite == 121 ? '请输入申请地点' : '请输入立案地点', trigger: 'blur' }">
                <a-input v-model="form.location" :disabled='openEdit' :placeholder="StepLite == 121 ? '请输入申请地点' : '请输入立案地点'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 3'>
              <a-form-model-item label="提交人" prop="submiter" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入提交人', trigger: 'blur' }">
                <a-input v-model="form.submiter" :disabled='openEdit' placeholder='请输入我方提交人' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2' style="width:33.3%;">
              <a-form-model-item label="收件地址：" prop="addr" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                <a-input v-model="form.addr" :disabled='openEdit' placeholder='请输入收件地址' style="width:100%;" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="法院地区" prop="court" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请选择法院地区', trigger: 'change' }">
                <a-cascader :options="options" placeholder="请选择法院地区" change-on-select
                  :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model='form.court'
                  @change='seachCourtList(form.court); form.court_id = null' :disabled='openEdit' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="管辖法院" prop="court_id" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请选择管辖法院', trigger: 'change' }">
                <a-select show-search v-model="form.court_id" placeholder="请选择管辖法院" :allowClear='true'
                  :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                  :not-found-content="null" :disabled='openEdit'>
                  <a-select-option v-for="d in courtList" :key="d.id">
                    {{ d.title }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <div class="">
            <a-form-model-item label="备注" v-if='!loading' labelAlign="left" style="margin-top: -15px;">
              <Textarea :content='form.content' @contentVal='(element) => { form.content = element }' :edit='openEdit'
                :keyArr="['time', 'user']" style="width: 100%;"> </Textarea>
            </a-form-model-item>
          </div>
          <div>
            <div class="licter" v-if="!openEdit">
              <label>补充材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon" style="margin-bottom:5px;">
              <div class="ilikebox" v-for="(i, index) in form.supp" :key="index">
                <div class="likebox" v-if="i.type == 1">
                  <div class="htit">
                    补充材料：电子
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="平台名称" :prop="'supp.' + index + '.platform'" :rules="{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.platform" :disabled="openEdit" placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{ span: 6 }" :wrapper-col="{ span: 24 }"
                        :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 2">
                  <div class="htit">
                    补充材料：微信
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="对方微信号" :prop="'supp.' + index + '.wx'" :rules="{
                        required: true,
                        message: '请输入对方微信号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.wx" :disabled="openEdit" placeholder="请输入对方微信号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }"
                        :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 3">
                  <div class="htit">
                    补充材料：现场
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="补充提交人" :prop="'supp.' + index + '.submiter'" :rules="{
                        required: true,
                        message: '请输入补充提交人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.submiter" :disabled="openEdit" placeholder="请输入补充提交人" />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 4">
                  <div class="htit">
                    补充材料：邮寄
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="单号" :prop="'supp.' + index + '.ship_no'" :rules="{
                        required: true,
                        message: '请输入单号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.ship_no" :disabled="openEdit" placeholder="请输入单号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'supp.' + index + '.tel'" :rules="{
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.tel" :disabled="openEdit" placeholder="请输入联系方式" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="收件人" :prop="'supp.' + index + '.receive_name'" :rules="{
                        required: true,
                        message: '请输入收件人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.receive_name" :disabled="openEdit" placeholder="请输入收件人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="寄出时间" :prop="'supp.' + index + '.ship_time'" :rules="{
                        required: true,
                        message: '请选择寄出时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="">
                        <label v-if="openEdit">{{
                          i.gout == 'a'
                            ? '签收时间:'
                            : i.gout == 'b'
                              ? '拒收时间:'
                              : '无'
                        }}</label>
                        <a-radio-group v-model="i.gout" :disabled="openEdit" style="white-space: nowrap" size="small"
                          v-else>
                          <a-radio-button :value="null" style="
                              width: 64px;
                              text-align: center;
                              font-size: 0.75rem;
                            ">无</a-radio-button>
                          <a-radio-button :value="'a'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="i.gout == 'a'"
                          :disabled="openEdit" style="width: 100%" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" v-if="i.gout == 'b'" />
                        <a-input disabled v-if="!i.gout" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="收件地址" :prop="'supp.' + index + '.addr'" :rules="{
                        required: true,
                        message: '请输入收件地址',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.addr" :disabled="openEdit"  type="textarea" placeholder="请输入收件地址" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit"  type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>

            <div class="licter" v-if="!openEdit">
              <label>接收材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1, 1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2, 1)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3, 1)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4, 1)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon">
              <div class="ilikebox" v-for="(i, index) in form.accept_file" :key="index">
                <div class="likebox" v-if="i.type == 1">
                  <div class="htit">
                    接收材料：电子
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'" :rules="{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.platform" :disabled="openEdit" placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 2">
                  <div class="htit">
                    接收材料：微信
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'" :rules="{
                        required: true,
                        message: '请输入对方微信号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.wx" :disabled="openEdit" placeholder="请输入对方微信号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 3">
                  <div class="htit">
                    接收材料：现场
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'" :rules="{
                        required: true,
                        message: '请输入接收人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.submiter" :disabled="openEdit" placeholder="请输入接收人" />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 4">
                  <div class="htit">
                    接收材料：邮寄
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'" :rules="{
                        required: true,
                        message: '请输入单号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.ship_no" :disabled="openEdit" placeholder="请输入单号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'" :rules="{
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.tel" :disabled="openEdit" placeholder="请输入联系方式" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'" :rules="{
                        required: true,
                        message: '请输入接收人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.receive_name" :disabled="openEdit" placeholder="请输入接收人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'" :rules="{
                        required: true,
                        message: '请选择寄出时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="">
                        <label v-if="openEdit">{{
                          i.gout == 'a'
                            ? '签收时间:'
                            : i.gout == 'b'
                              ? '拒收时间:'
                              : '无'
                        }}</label>
                        <a-radio-group v-model="i.gout" :disabled="openEdit" size="small" style="white-space: nowrap"
                          v-else>
                          <a-radio-button :value="null" style="
                              width: 64px;
                              text-align: center;
                              font-size: 0.75rem;
                            ">无</a-radio-button>
                          <a-radio-button :value="'a'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="i.gout == 'a'"
                          :disabled="openEdit" style="width: 100%" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" v-if="i.gout == 'b'" />
                        <a-input disabled v-if="!i.gout" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="收件地址" :prop="'accept_file.' + index + '.addr'" :label-col="{ span: 12 }"
                        :wrapper-col="{ span: 24 }" :rules="{
                          required: true,
                          message: '请输入收件地址',
                          trigger: 'blur',
                        }">
                        <a-input v-model="i.addr" :disabled="openEdit" type="textarea" placeholder="请输入收件地址" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'"
                        :label-col="{ span: 12 }" :wrapper-col="{ span: 24 }">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item prop="files" :rules="{ required: false, message: '请上传附件', trigger: 'change' }">
            <Upload @isDisabled="parentHandle" :fList='form.files' @upFileAfter='lisUpload' :disabled="openEdit" :edit='openEdit'
              v-if='!loading' :Wid='"70px"' />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if='!openEdit' style="text-align:center;">
            <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button :disabled="disabledShow" type="primary" style="width:148px;">
                提交
              </a-button>
            </a-popconfirm>
            <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click='reset'>取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-spin>
  </drag-modal>

</template>
<script>
import Textarea from '@/components/textarea'
import liteKey from "./../liteKey.json"
import Upload from "@/components/uploads"
import { sqbqadd, sqbqedit, sqbqlists, delJd } from "@/server/speed"
import { getDirectory, arbOrg, by_type, attorneyoptions } from "@/server/directory"
import { stepFiles } from "@/server/debtor"
import Nscroll from "@/components/nscroll"
import { mapGetters, mapActions } from 'vuex'
import city from "@/assets/js/city.json"
import { citySort } from '@/assets/js/unit'
import { convertToFullwidthBrackets } from "@/assets/js/caseNumber"
export default {
  name: 'preservation',
  components: {
    Textarea, Upload, Nscroll
  },
  props: {
    preservates: Object
  },
  data() {
    return {
      isAllDis: this.$route.query.t,
      StepLite: this.$store.state.StepLite,
      loading: true,
      openEdit: false,
      form: {
        step: 0,
        cause_id: '',
        agent: [],
        agent_model: undefined,
        cost_model: undefined,
        accept_file: [],//接收材料
        supp: [],//补充材料
        files: [],//附件
        preservation_time: null,//保全时间
        preservation_case_no: null,//执保案号
        ruling_case_no: null,//裁定案号
        uname: [{ v: '' }],//承办人
        tel: [{ v: '' }],//承办人联系方式
        content: [{ content: '' }],//备注
        court_id: '',
        type: 1,//立案方式
        platform: '',//平台名称
        time: '',//材料提交时间
        ship_no: '',//运单号
        contact_phone: '',//联系方式
        filename: '',//材料名称
        receive_name: '',//收件人
        ship_time: '',//寄出时间
        gout: null,
        receive_time: '',//签收时间
        return_time: '',//拒收时间
        addr: '',//收件地址
        time: '',//立案时间
        location: '',//立案地点
        submitter: '',//提交人
        stage: '',
        stage_inside: '',
        stage_outside: '',
      },
      rules: {},
      disabledShow: false,
      data: [],
      agentList: [],
      agentmodelList: [],
      agent_model: '',
      courtList: [],
      plainOptions: [
        { label: '网立', value: 1 },
        { label: '邮寄', value: 2 },
        { label: '现场', value: 3 },
      ],
      options: citySort(city),
      costmodelList: []
    }
  },
  computed: {
    ...mapGetters([
      'litetit',
      'Edit'
    ]),
    // agentModelWidthStyle() {
    //   return {
    //     width: this.openEdit ? '100%' : '85%',
    //     marginRight: this.openEdit ? '0px' : '-10px',
    //   };
    // },
    // agentModelWidthStyle1() {
    //   return {
    //     width: this.openEdit ? '100%' : '85%',
    //     marginRight: this.openEdit ? '0' : '-10px',
    //   };
    // }
  },
  created() {
    this.getBytype()
    if (this.Edit) {
      this.$nextTick(() => {
        sqbqlists({ cause_id: this.$store.state.cause.id, step: this.StepLite }).then(e => {
          if (e.list.length > 0) {
            e.list.map(ele => {
              ele.sqbq.supp = Object.keys(ele.sqbq.supp).map(key => ele.sqbq.supp[key])
              ele.sqbq.accept_file = Object.keys(ele.sqbq.accept_file).map(key => ele.sqbq.accept_file[key])
              ele.sqbq.content = !ele.sqbq.content || (ele.sqbq.content && ele.sqbq.content.length == 0) ? [{}] : ele.sqbq.content
              ele.sqbq.court = ele.sqbq.courte ? [ele.sqbq.courte.province_id, ele.sqbq.courte.city_id, ele.sqbq.courte.area_id] : [110000]
              this.seachCourtList(ele.sqbq.court)
              //   ele.sqbq.content = JSON.stringify(ele.sqbq.content) == "{}" ? [{ content: '' }] : Object.keys(ele.sqbq.content).map(key => ele.sqbq.content[key]);
              ele.sqbq.supp.map(element => {
                if (element.type * 1 == 4) {
                  element.gout = (!element.receive_time && !element.return_time) ? null : (element.receive_time ? "a" : "b")
                }
              })
              ele.sqbq.accept_file.map(element => {
                if (element.type * 1 == 4) {
                  element.gout = (!element.receive_time && !element.return_time) ? null : (element.receive_time ? "a" : "b")
                }
              })
              ele.sqbq.uname = ele.sqbq.uname ? ele.sqbq.uname.split(",").map(ele => { return { v: ele } }) : [{ v: '' }]
              ele.sqbq.tel = ele.sqbq.tel ? ele.sqbq.tel.split(",").map(ele => { return { v: ele } }) : [{ v: '' }]
            })
            this.$store.dispatch("settime", e.list[0].sqbq.update_time)
            this.Infokey({ key: 'infoList', value: e.list })
            this.see(0)
          }
        })
      })
      this.openEdit = true;
      this.loading = false;
    } else {
      this.loading = false;
    }
  },
  methods: {
    convertToFullwidthBrackets,
    getBytype() {
      this.agentmodelList = this.preservates.agent_model
      this.costmodelList = this.preservates.cost_model
    },
    agentmodelChange(e) {
      this.agentmodelList.map(item => {
        if (item.id == e) {
          this.getatt(item.id)
        }
      })
    },
    getatt(id) {
      attorneyoptions(id).then(res => {
        this.agentList = res
      })
    },
    ck(id) {
      if(id == this.form.type) {
        return
      }else{
        this.form.type = id
      }
    },
    parentHandle(data) {
      this.disabledShow = data
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove'
    }),
    delStep() {
      let curIndex = this.$store.state.DisForm.curIndex
      let step_id = this.$store.state.DisForm.infoList[curIndex].id
      delJd({ step_id: step_id }).then(e => {
        this.$message.success("已提交审核")
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    async copydel(index) {        //删除进度 
      await this.Newdel({
        index: index, formKey: ['preservation_time', 'ruling_case_no', 'preservation_case_no', 'uname', 'tel', 'court_id', 'court',
          'content', 'type', 'files', 'supp', 'accept_file', 'platform', 'time', 'ship_no', 'contact_phone',
          'filename', 'receive_name', 'ship_time', 'receive_time', 'return_time', 'addr', 'time', 'location', 'submitter', 'agent', 'agent_model', 'cost_model'], valkey: "sqbq"
      }).then(e => {
        this.form = JSON.parse(JSON.stringify(e));
        this.loading = false;
      })
    },
    async see(index) {        //查看切换 审批
      this.loading = true;
      let form = this.form;
      this.seeInfo({
        index: index, formKey: ['preservation_time', 'ruling_case_no', 'preservation_case_no', 'uname', 'tel', 'court_id', 'court',
          'content', 'type', 'files', 'supp', 'accept_file', 'platform', 'time', 'ship_no', 'contact_phone',
          'filename', 'receive_name', 'ship_time', 'receive_time', 'return_time', 'addr', 'time', 'location', 'submitter', 'agent', 'agent_model', 'cost_model'], valkey: "sqbq"
      }).then(e => {
        let form = JSON.parse(JSON.stringify(e));
        if (form.agent == null || form.agent == NaN) {
          form.agent = []
        }
        if (form.agent_model == 0 || form.agent_model == 3 || form.agent_model == 4 || form.agent_model == 10) {
          form.agent_model = ''
        } else {
          form.agent_model = Number(form.agent_model)
        }
        this.old_agent_model = form.agent_model
        this.old_agent = form.agent
        this.agentmodelList.map(item => {
          if (item.id == form.agent_model) {
            this.getatt(item.id)
          }
        })
        if (form.cost_model == 0) {
          form.cost_model = ''
        } else {
          form.cost_model = Number(form.cost_model)
        }
        form.gout = (!form.receive_time && !form.return_time) ? null : (form.receive_time ? "a" : "b")
        this.form = form
        this.loading = false;
      })
    },
    add() {
      this.form.uname.push({ v: '' })
      this.form.tel.push({ v: '' })
    },
    dels(index) {
      this.form.uname.splice(index, 1)
      this.form.tel.splice(index, 1)
    },
    del(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    },
    gtLetter() {
      return (JSON.parse(localStorage.getItem("pName")) || []).concat(this.fy).filter(ele => { return ele })
    },
    handleSearch(value) {
      this.data = !value ? [] : this.gtLetter().filter(ele => { return ele.indexOf(value) >= 0 });
    },
    seachCourtList(val) {      //搜索法院
      let province_id = val[0],
        city_id = val.length > 1 ? val[1] : '',
        area_id = val.length > 2 ? val[2] : '';
      getDirectory({ province_id: province_id, city_id: city_id, area_id: area_id }).then(e => {
        this.courtList = e.list
      })
    },
    plusAdd(type, lite) {
      let smForm = {
        type: type,
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          let content = form.content.filter(e => {
            return e.content
          })
          form.content = content;
          form.uname = form.uname.map(ele => {
            return ele.v
          }).join(",")

          form.tel = form.tel.map(ele => {
            return ele.v
          }).join(",")
          for (let val in form) {
            if (!form[val]) {
              delete form[val]
            }
          }
          if (form.files && form.files.length > 0) {
            form.files = form.files.map(ele => {
              return ele.upload_id || ele
            })
          }
          if (form.ruling_case_no) {
            form.ruling_case_no = this.convertToFullwidthBrackets(form.ruling_case_no).replace(/\s/g, '');
          }
          if (form.preservation_case_no) {
            form.preservation_case_no = this.convertToFullwidthBrackets(form.preservation_case_no).replace(/\s/g, '');
          }
          form.supp.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })

          form.accept_file.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd = this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0 ? true : false   //当前是否是在修改下的新增
          if (this.$store.state.cause.cause_type == 1) {
            form.stage = '诉讼阶段'
          } else {
            form.stage = '仲裁阶段'
          }
          form.stage_outside = '保全'
          form.stage_inside = '立案'
          form.step = Number(this.StepLite)
          if (this.Edit && !isEditCopyAdd) {      //修改
            let id = this.$store.state.DisForm.infoList[curIndex].sqbq.id
            form.id = id;
            sqbqedit(form).then(e => {
              this.$message.success({ content: '修改成功', key: 'updatable' });
              // this.$parent.$parent.init(this.$store.state.cause.id)

              this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              setTimeout(() => {
                this.$parent.$parent.init(this.$store.state.cause.id)
                // this.$parent.$parent.$forceUpdate();
              }, 100)

              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            sqbqadd(form).then(e => {
              this.$message.success({ content: '新增成功', key: 'updatable' });
              this.$parent.$parent.init(this.$store.state.cause.id)
              this.$parent.$parent.init(this.$store.state.cause.id)
              this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset() {
      this.reMove().then(e => {
        // this.$refs.forms.resetFields();
        this.$store.dispatch('openkey', { key: 'preservation', by: false })
      })

    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
  }
}
</script>
<style lang="less" scoped>
.morebar {
  position: relative;
  display: flex;
  margin-bottom: 10px;
  height: 40px;
  align-items: center;

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
}

.btns {
  position: absolute;
  right: -40px;
  top: 50%;
  transform: translateY(-50%);
  width: 12%;
  display: flex;
  font-size: 1.25rem;
  justify-content: space-between;
  padding-left: 20px;
  height: 30px;
  align-items: center;

  .i {
    cursor: pointer;
  }

  .add {
    color: #118afc;
  }

  .del {
    color: #f00;
  }
}

.ckbox {
  overflow: hidden;

  .li {
    float: left;
    background: url('../../../assets/img/ico.png') no-repeat left center;
    background-size: 15px 15px;
    font-size: 0.75rem;
    padding-right: 20px;
    padding-left: 20px;
    cursor: pointer;
  }

  .cur {
    background-image: url('../../../assets/img/icoh.png');
  }
}

.newtypelist {
  padding: 0 20px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;

  .li {
    width: 33.3%;
    display: inline-block;
    // padding: 0 12px;
  }
}

.newtypelist1 {
  // padding: 0 20px;
}

.ilikecon {
  max-height: 400px;
  overflow: auto;
}

.intopbtn .rd {
  opacity: 0.8;
  border-color: #ff9800;
  color: #ff9800;
}

.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;

  .htit {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 0;
  }

  /deep/ .ant-form-item-label {
    text-align: left;
  }
}

.licter {
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 0.875rem;
    text-align: left;
    // width: 72px;
    color: #333;
    line-height: 30px;
    margin-right: 10px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 0.875rem;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}
</style>